import { render, staticRenderFns } from "./RegistraFermi.vue?vue&type=template&id=19682f11&scoped=true&"
import script from "./RegistraFermi.vue?vue&type=script&lang=js&"
export * from "./RegistraFermi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19682f11",
  null
  
)

export default component.exports